import { FormattedMessage } from 'react-intl'

import { Currency } from '@/constants/currency'
import { getFlagUrlByCurrency } from '@/lib/images'
import { formatAmount } from '@/lib/money'
import { cn, getAnimationKey } from '@/lib/utils'
import { Card, MotionDiv, Skeleton, Typography } from '@/shared/ui'

type Props = {
  currency?: Currency
  totalWallets?: number
  totalBalance?: number
  isPending: boolean
  className?: string
}

export const BalanceCard = ({
  currency = Currency.USDC,
  totalWallets = 0,
  totalBalance = 0,
  isPending,
  className,
}: Props) => {
  return (
    <Card
      size="widget"
      className={cn(
        'flex w-full flex-col items-center justify-between',
        className,
      )}
    >
      <div className="flex w-full flex-wrap items-center justify-between gap-3 md:flex-nowrap md:gap-0">
        <div className="flex flex-col">
          <div className="flex items-center gap-1">
            <img
              src={getFlagUrlByCurrency(currency)}
              className="size-4"
              alt=""
              aria-hidden
            />
            <Typography variant="body-small">
              <FormattedMessage
                id="dashboard.totalBalance"
                defaultMessage="Total balance"
              />
            </Typography>
            <Typography variant="body-small">
              <FormattedMessage
                id="dashboard.accountsCount"
                defaultMessage="{count, plural, =0 {} one {(# account)} other {(# accounts)}}"
                values={{ count: totalWallets }}
              />
            </Typography>
          </div>

          <div className="p-1" />

          <MotionDiv key={getAnimationKey(isPending)}>
            {isPending ? (
              <Skeleton className="h-[33px] w-36" />
            ) : (
              <Typography variant="h3">
                {formatAmount({
                  amount: totalBalance,
                  currency,
                })}
              </Typography>
            )}
          </MotionDiv>
        </div>
      </div>
    </Card>
  )
}
